import HttpService from 'commonjs-tools/build/http-service';

let _browsesService;
class BrowsesService extends HttpService {

    constructor(props) {
        super(props);
    }

    get(path) {
        return this.makeRequest('get', {path: path});
    }
}

if(!_browsesService){
    _browsesService = new BrowsesService();
}

export default _browsesService;
